import { Grid, Loader, Table } from 'semantic-ui-react'
import styled from 'styled-components'

export const StyledEnergyWrapper = styled.div`
display: flex !important;
align-items: center;
justify-content: end;
gap: 10px;
 a {
  background-color: #f8ffff !important;
  color: #276f86 !important;
  box-shadow: 0 0 0 1px #a9d5de inset, 0 0 0 0 transparent;
  font-style: italic;
  cursor: default !important;
}
.ui.label>.detail {
  opacity: 1 !important;
  margin-left: 0.5rem !important;
}
.visible.transition {
  display: inline !important;
}
.ui.loader:after, .ui.loader:before {
  width: 1.5rem !important;
  height: 1.5rem !important;
  top: -7px !important;
}
`
export const StyledLoader = styled(Loader)`
width: 1.5rem !important;
height: 1.5rem !important;
.ui.loader:after, .ui.loader:before {
  width: 1.5rem !important;
  height: 1.5rem !important;
}
`
export const StyledGridColumn = styled(Grid.Column)`
.ui.loader:after, .ui.loader:before {
  width: 1.8rem !important;
  height: 1.8rem !important;
  top: -7px !important;
}
`
export const StyledTable = styled(Table)`
 th {
  min-width: 200px !important;
 }
 td {
  min-width: 200px !important;
 }
`